interface ProfileIconProps {
    className?: string;
}

export const ProfileIcon = ({ className }: ProfileIconProps = {}) => (
    <svg className={className || "block size-full"} fill="none" viewBox="0 0 29 29">
        <path
            clipRule="evenodd"
            d="M0 14.2133C0 6.3761 6.3761 0 14.2133 0C22.0506 0 28.4266 6.3761 28.4266 14.2133C28.4266 22.0506 22.0506 28.4267 14.2133 28.4267C6.3761 28.4267 0 22.0506 0 14.2133ZM23.2201 19.9002V21.8061C24.9535 19.7533 26.0009 17.1037 26.0009 14.213C26.0009 7.71276 20.7132 2.42477 14.213 2.42477C7.71276 2.42477 2.42477 7.71276 2.42477 14.213C2.42477 17.1037 3.47245 19.7533 5.20585 21.8061V19.9002C5.20585 17.6646 7.01125 15.8592 9.24306 15.8592H11.5706C9.88203 14.9255 8.73707 13.1287 8.73707 11.0646C8.73707 8.04283 11.1906 5.58897 14.213 5.58897C17.2354 5.58897 19.6886 8.04283 19.6886 11.0646C19.6886 13.1287 18.5433 14.9255 16.8554 15.8592H19.1788V15.8602C19.1796 15.8602 19.1802 15.8599 19.1809 15.8597C19.1815 15.8594 19.1821 15.8592 19.1829 15.8592C21.4078 15.8592 23.2201 17.6646 23.2201 19.9002Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
